/*
action types 
*/
export const UPDATE_APP_AUTH = "update_app_auth";
export const UPDATE_APP_TOKEN = "update_app_token";
export const UPDATE_APP_ADDRESS = "update_app_address";
export const UPDATE_APP_LANG = "update_app_lang";
export const UPDATE_APP_FORUMCATEGORYID = "update_app_forumcategoryid";

/*
initial state
*/

export const INITIAL_APP_STATE = {
    username: "",
    password: "",
    accessToken: "",
    isSuperUser: false,
    isAdmin: false,
    forumName: "",
    forumId: "",
    forumCategoryId: "",
    topicName: "",
    topicId: "",
    lang: "kr",
    email: "",
};
